export default "__VITE_ASSET__DZKYXOQ$__"